module.exports = __webpack_public_path__ + "static/media/shake.e324d300.svg";